import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActiveOrgService } from '../services/active-org.service';

/**
 * Додає заголовок X-Active-Organization: {type}:{organizationId} до API-запитів,
 * коли support обрав активну організацію. Реєструється ПІСЛЯ authInterceptor.
 *
 * - Тільки запити на наш API (environment.apiUrl).
 * - Не чіпаємо /auth/* (логін/реєстрація не потребують контексту організації).
 * - Для менеджера, коли вибір відсутній, заголовок не додається; бек його все одно ігнорує.
 */
export const activeOrgInterceptor: HttpInterceptorFn = (req, next) => {
  const activeOrg = inject(ActiveOrgService);
  const headerValue = activeOrg.headerValue();

  if (!headerValue) {
    return next(req);
  }

  const isApiRequest = req.url.startsWith(environment.apiUrl);
  const isAuthRequest = req.url.includes('/auth/');

  if (!isApiRequest || isAuthRequest) {
    return next(req);
  }

  const clonedReq = req.clone({
    headers: req.headers.set('X-Active-Organization', headerValue),
  });
  return next(clonedReq);
};
